import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import { LoaderEvent } from './../../shared/message.event';
import { Input, Output, EventEmitter } from '@angular/core';
import { UtilityFunctions } from '../../shared/utility-functions';
@Component({
    selector: 'app-view-members',
    templateUrl: './view-members.component.html',
    styleUrls: ['./view-members.component.css'],
    providers: [LoaderEvent],
    exportAs: 'ViewMembers'
})
export class ViewMembersComponent implements OnInit {
    @ViewChild('childModal') childModal: ModalDirective;
    @Input() message = '';
    @Input() popupTitle;
    @Input() cancleButton;
    // @Output() notify: EventEmitter<string> = new EventEmitter<string>();
    @Output() notifyDelete = new EventEmitter<boolean>();
    @Input() memberList;
    @Output() removeObj = new EventEmitter<any>();
    @Output() notify = new EventEmitter<any>();
    @Input() history;
    private utilityFunctions = new UtilityFunctions();
    constructor(private router: Router, private loaderEvent: LoaderEvent) {
    }

    public showChildModal(): void {
        try {
            this.childModal.config.backdrop = false;
            this.childModal.config.keyboard = false;
            this.utilityFunctions.setBackGroundBlack();
            this.childModal.show();

        } catch (e) {
            console.log(e);
        }
    }

    public hideChildModal(): void {
        try {
            this.utilityFunctions.removeBackGroundBlack();
            this.childModal.hide();
        } catch (e) {
            console.log(e);
        }
    }

    ngOnInit() {
    }
    /**
     * Remove item from list
     * 
     * @param {any} member 
     * 
     * @memberof ViewMembersComponent
     */
    removeFromSelection(member) {
        this.notify.emit(member);
        if (this.memberList.length === 0) {
            this.utilityFunctions.removeBackGroundBlack();
            this.childModal.hide();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/view-members/view-members.component.ts